import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PARTICIPANT_REQUEST = 'FETCH_PARTICIPANT_REQUEST';
export const PARTICIPANT_FAILURE = 'FETCH_PARTICIPANT_FAILURE';
export const PARTICIPANT_SUCCESS = 'FETCH_PARTICIPANT_SUCCESS';

/**
 * Participants of ONE competition.
 *
 * The competition is required. Without it this asks for every participant
 * row in the database — fifteen thousand and growing — and the API resolves
 * an effective-dated rank and profile snapshot for each one, which cannot
 * finish inside max_execution_time. Both callers only ever displayed one
 * competition's participants anyway; they used to fetch everything and throw
 * the rest away client-side.
 */
export const fetchParticipants = (competitionId) => {
    return function(dispatch) {
        if (!competitionId) {
            // Nothing to scope the request to. Asking unfiltered is what
            // times the API out, so refuse rather than degrade.
            return Promise.resolve();
        }

        dispatch(fetchRequest(competitionId));
        return axios(apiRequestOptions(apiPath.PARTICIPANT.LIST, {
            'application.competition': competitionId,
        }))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data, competitionId)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = (competitionId) => {
    return {
        type: PARTICIPANT_REQUEST,
        competitionId,
    }
};

const fetchFailure = (error) => {
    return {
        type: PARTICIPANT_FAILURE,
        error,
    }
};

const fetchSuccess = (data, competitionId) => {
    return {
        type: PARTICIPANT_SUCCESS,
        data,
        competitionId,
    }
};